import { useState ,useEffect,useContext} from "react";
import { AppContext } from "../AppContext";
import "./shop.css";
export default function Project() {
  const { data } = useContext(AppContext);
  const [state, setstate] = useState(0);
  const [val, setval] = useState(null);
  const [open, setOpen] = useState(false);
 
   function scrollTop (){
    document.getElementById("app").scrollTo({
      top: 0,
      behavior: "smooth" // 平滑滚动
    }); 
  }
 
  useEffect(() => {

    
  }, []); // 空数组 => 只在首次挂载时执行（等价于 componentDidMount）

  return (
    <div id="pShop">
      <img src={`/image/7.png`} className="pageTitle" />
      <div  className="pContent" >
        <img src={`/image/WechatIMG1570.jpg`} className="card1" />
        
      </div>
      
      
      <section  onClick={()=>scrollTop()} id="toTop"><span >PAGE TOP</span></section>
    </div>
  );
}